<template>
  <div class="animated fadeIn">
    <!-- <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link
            :to="{ path: '/setup/plan-pricing' }"
            class="vx-row mt-4"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4 class="mt-1">{{ $t("setup.label.planContent") }}</h4>
          </router-link>
        </li>
      </ul>
    </div> -->
    <div v-if="loading">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row" v-else>
      <div class="w-full ml-4 mr-4">
        <vx-card class="digital-card">
          <div v-if="planId" class="w-full mb-2">
            <div class="version-container">
              <div class="tag">
                {{ mode === "edit" ? "DRAFT" : planStatus }}
              </div>
              <div class="tag" v-if="planVersion > 0">
                {{$t("setup.label.Version")}} :
                {{
                  planStatus === "ACTIVE" && mode === "edit"
                    ? planVersion + 1
                    : planVersion
                }}
              </div>
              <div
                class="tag-approval"
                v-if="planStatus === 'DRAFT' && mode != 'view'"
                @click="makerCheckerApproval()"
              >
                {{ $t("setup.label.requestApproval") }}
              </div>
            </div>
          </div>
          <div class="flex mb-3 align-items-center justify-between">
            <div class="flex text-center">
              <div class="dropdown-with-label mr-2" v-if="mode != 'view'">
                <small class="date-label">
                  {{ $t("setup.label.ContentType") }}
                </small>
                <v-select
                  label="mCodeValue"
                  v-model="selectedType"
                  :options="filteredTypeOptions"
                  :placeholder="$t('setup.label.SelectType')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-14vw w-full mb-2"
                >
                </v-select>
              </div>
              <div v-if="selectedType" class="dropdown-with-label mr-2">
                <small class="date-label">
                  {{ $t("setup.label.Language") }}
                </small>
                <v-select
                  label="type"
                  v-model="selectedLanguage"
                  :options="LanguageList || []"
                  :placeholder="$t('setup.label.SelectLanguage')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-14vw w-full mb-2"
                >
                </v-select>
              </div>
              <div v-if="selectedType" class="dropdown-with-label mr-2">
                <small class="date-label">
                  {{ $t("setup.label.contentTag") }}
                </small>
                <v-select
                  label="mCodeValue"
                  v-model="selectedContentTag"
                  :options="contentTagList || []"
                  :placeholder="$t('setup.label.SelectContentTag')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-14vw w-full mb-2"
                >
                </v-select>
              </div>
              <div
                v-if="selectedContentTag && selectedType"
                class="dropdown-with-label mr-2"
              >
                <small class="date-label">
                  {{ $t("setup.label.contentTagValue") }}
                </small>
                <v-select
                  label="mCodeValue"
                  v-model="selectedContentTagValue"
                  :options="contentTagValueList || []"
                  :placeholder="$t('setup.label.SelectContentTagValue')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-14vw w-full mb-2"
                >
                </v-select>
              </div>
            </div>
            <div class="float-right mr-2">
              <vs-button
                v-if="
                  selectedType && selectedType.mCodeValue == 'Digital_Image'
                "
                icon-pack="feather"
                icon="icon-plus"
                style="top: 11px"
                @click="contentUploadPopup = true"
                size="small"
                :disabled="!selectedType || !selectedLanguage"
                >{{ $t("setup.label.UploadDigitalImage") }}</vs-button
              >
              <vs-button
                v-else
                icon-pack="feather"
                icon="icon-plus"
                style="top: 11px"
                v-show="mode != 'view'"
                @click="createContentPopup = true"
                size="small"
                :disabled="
                  !selectedType ||
                  !selectedLanguage ||
                  !selectedContentTag ||
                  !selectedContentTagValue
                "
                >{{
                  $t("setup.label.Add") + " " + $t("setup.label.digitalContent")
                }}</vs-button
              >
            </div>
            <!-- <div
              class="center mt-3"
              v-if="
                selectedLanguage &&
                selectedType &&
                selectedType.value == 'featurelist'
              "
            >
              <span class="p-2">
                <vs-button @click="createPlanContentMethod()">{{
                  $t("setup.label.CreateFeatureList")
                }}</vs-button>
              </span>
            </div>
            <div
              class="center mt-3"
              v-if="
                selectedLanguage &&
                selectedType &&
                selectedType.value == 'termsconditions'
              "
            >
              <span class="p-2">
                <vs-button @click="createPlanContentMethod()">{{
                  $t("setup.label.createTermsConditions")
                }}</vs-button>
              </span>
            </div>
            <div
              class="center mt-3"
              v-if="
                selectedLanguage &&
                selectedType &&
                selectedType.value == 'Planname'
              "
            >
              <span class="p-2">
                <vs-button @click="createPlanContentMethod()">{{
                  $t("setup.label.CreatePlanName")
                }}</vs-button>
              </span>
            </div>
            <div
              class="center mt-3"
              v-if="
                selectedLanguage &&
                selectedType &&
                selectedType.value == 'Plandescription'
              "
            >
              <span class="p-2">
                <vs-button @click="createPlanContentMethod()">{{
                  $t("setup.label.CreatePlanDescription")
                }}</vs-button>
              </span>
            </div> -->
          </div>

          <!-- <div v-if="selectedLanguage && selectedType && selectedType.value">
            <template>
              <div id="plancontent">
                <vue-editor v-model="content"></vue-editor>
              </div>
            </template>
          </div> -->
          <TreeNode
            v-if="treeData"
            v-for="node in treeData"
            :key="node.id"
            :node="node"
            :mode="mode"
            :depth="0"
            @viewContent="handleViewContent"
            @editContent="handleEditContent"
            @deleteContent="handleDeleteContent"
            @addLanguage="handleAddLanguage"
          />
          <div v-if="planId" class="vx-row center mb-10">
            <div class="vx-col w-full">
              <vs-button
                class="mr-3 footerButton-next"
                v-show="mode != 'view'"
                @click="$emit('completed')"
                >{{ $t("setup.label.SaveAndContinue") }}</vs-button
              >
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        class="popup-close mid-popup popup-width"
        classContent="popup-example"
        :title="$t('setup.label.UploadDigitalImage')"
        :active.sync="contentUploadPopup"
        @update:active="handlePopupClose"
      >
        <form>
          <div>
            <template>
              <div id="plancontent">
                <vue-editor
                  v-model="content"
                  :editor-toolbar="customToolbar"
                ></vue-editor>
              </div>
            </template>
          </div>
          <div class="center mt-10">
            <span class="ml-1 mr-1">
              <vs-button
                :disabled="!content"
                @click="createPlanContentMethod"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("setup.label.Submit") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        class="popup-close mid-popup popup-width"
        :title="$t('setup.label.EditDigitalContent')"
        :active.sync="editContentPopup"
        @update:active="handlePopupClose"
      >
        <form>
          <div>
            <template>
              <div id="plancontent">
                <vue-editor v-model="editData.text"></vue-editor>
              </div>
            </template>
          </div>
          <div class="center mt-10">
            <span class="ml-1 mr-1">
              <vs-button
                @click="updatePlanContentMethod"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("setup.label.Update") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        class="popup-close mid-popup popup-width"
        :title="$t('setup.label.AddDigitalContent')"
        :active.sync="createContentPopup"
        @update:active="handlePopupClose"
      >
        <form>
          <div>
            <template>
              <div id="plancontent">
                <vue-editor v-model="content"></vue-editor>
              </div>
            </template>
          </div>
          <div class="center mt-10">
            <span class="ml-1 mr-1">
              <vs-button
                :disabled="!content"
                @click="createPlanContentMethod"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("setup.label.Submit") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        class="popup-close mid-popup popup-width"
        :title="$t('setup.label.ViewDigitalContent')"
        :active.sync="viewContentPopup"
        @update:active="handlePopupClose"
      >
        <form>
          <div>
            <template>
              <div id="plancontent">
                <vue-editor disabled v-model="editData.text"></vue-editor>
              </div>
            </template>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('setup.label.SelectLanguage')"
        :active.sync="selectLanguagePopup"
        class="popup-close"
        @update:active="handleLanguagePopupClose"
      >
        <div class="vx-row mt-4">
          <div class="vx-col w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.Language")
              }}</small>
              <v-select
                label="type"
                v-model="selectedNewLanguage"
                :options="languageData || []"
                :reduce="(obj) => obj.id"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full mb-2"
              >
              </v-select>
            </div>
          </div>
          <div v-if="selectedNewLanguage" class="vx-col w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.contentTag")
              }}</small>
              <v-select
                label="mCodeValue"
                v-model="selectedContentTag"
                :options="contentTagList || []"
                :reduce="(obj) => obj.id"
                :placeholder="$t('setup.label.SelectContentTag')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full mb-2"
              >
              </v-select>
            </div>
          </div>
          <div
            v-if="selectedContentTag && selectedNewLanguage"
            class="vx-col w-full"
          >
            <div class="dropdown-with-label">
              <small class="date-label font-semibold">{{
                $t("setup.label.contentTagValue")
              }}</small>
              <v-select
                label="mCodeValue"
                v-model="selectedContentTagValue"
                :options="contentTagValueList || []"
                :reduce="(obj) => obj.id"
                :placeholder="$t('setup.label.SelectContentTagValue')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full mb-2"
              >
              </v-select>
            </div>
          </div>
        </div>
        <div class="center mt-10">
          <span class="ml-1 mr-1">
            <vs-button
              :disabled="!selectedNewLanguage"
              @click="onClickNext"
              class="footerButton-next"
              style="top: 0px"
              >{{ $t("setup.label.Next") }}</vs-button
            >
          </span>
        </div>
      </vs-popup>
    </div>
    <delete-popup
      :deletePopup="deleteContentPopup"
      :title="$t('setup.label.DigitalContent')"
      @deletePressed="deleteContentData(dataToDelete)"
      @cancelPressed="deleteContentPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { VueEditor } from "vue2-editor";
import { mapState } from "vuex";
import TreeNode from "../../../components/treeView.vue";
import vSelect from "vue-select";

export default {
  props: {
    treeData: {
      type: Array,
      required: true,
    },
    discId: Number,
    promoId: Number,
    planId: Number,
    planVersion: Number,
    planStatus: String,
    mode: String,
  },
  data() {
    return {
      loading: false,
      editContentPopup: false,
      createContentPopup: false,
      viewContentPopup: false,
      deleteContentPopup: false,
      selectLanguagePopup: false,
      contentUploadPopup: false,
      screen: "",
      editData: {
        planId: "",
        text: "",
        type: "",
        locale: "",
        docId: "",
      },
      file: "",
      content: "",
      selectedLanguage: "",
      selectedNewLanguage: "",
      selectedNewType: "",
      selectedType: null,
      treeSelectedLanguage: null,
      treeContentType: null,
      dataToDelete: null,
      customToolbar: [["link", "image", "video"]],
      selectedContentTagValue: "",
      selectedContentTag: "",
    };
  },
  components: {
    AtomSpinner,
    VueEditor,
    vSelect,
    TreeNode,
  },

  computed: {
    ...mapState({
      termsAndConditions: (state) => state.planPrice.termsAndConditions,
      LanguageList: (state) => state.planPrice.localeLanguage,
      typeOptions: (state) => state.planPrice.contentType,
      discountTypeOptions: (state) => state.planPrice.discountContentType,
      promoTypeOptions: (state) => state.planPrice.promoContentType,
      contentTagList: (state) => state.planPrice.contentTagData,
      contentTagValueList: (state) => state.planPrice.contentTagValueData,
    }),
    languageData() {
      return this.LanguageList;
    },
    filteredTypeOptions() {
      if (this.planId) {
        if (!Array.isArray(this.termsAndConditions)) {
          return this.typeOptions;
        }
        return this.typeOptions.filter(
          (type) =>
            !this.termsAndConditions.some(
              (term) => term.type === type.mCodeValue
            )
        );
      } else if (this.discId) {
        if (!Array.isArray(this.termsAndConditions)) {
          return this.discountTypeOptions;
        }
        return this.discountTypeOptions.filter(
          (type) =>
            !this.termsAndConditions.some(
              (term) => term.type === type.mCodeValue
            )
        );
      } else if (this.promoId) {
        if (!Array.isArray(this.termsAndConditions)) {
          return this.promoTypeOptions;
        }
        return this.promoTypeOptions.filter(
          (type) =>
            !this.termsAndConditions.some(
              (term) => term.type === type.mCodeValue
            )
        );
      }
    },
  },
  methods: {
    handlePopupClose(isActive) {
      if (!isActive) {
        this.content = "";
        this.selectedType = null;
        this.selectedLanguage = null;
        this.selectedNewLanguage = null;
        this.selectedNewType = null;
        this.treeSelectedLanguage = null;
        this.treeContentType = null;
      }
    },
    handleLanguagePopupClose(isActive) {
      if (!isActive) {
        this.content = "";
        this.selectedType = null;
        this.selectedLanguage = null;
        this.selectedNewLanguage = null;
        this.selectedNewType = null;
      }
    },
    handleViewContent(data) {
      this.viewContentData(data.children[0]);
    },
    handleEditContent(data) {
      this.editContentData(data.children[0]);
    },
    async handleDeleteContent(data) {
      this.dataToDelete = data.children[0];
      this.deleteContentPopup = true;
    },
    async handleAddLanguage(data) {
      this.content = "";
      this.selectedType = "";
      this.selectedLanguage = "";
      this.selectedNewType = data.children[0].children[0].type;
      this.selectLanguagePopup = true;
    },
    onClickNext() {
      this.treeContentType = this.selectedNewType;
      this.treeSelectedLanguage = this.selectedNewLanguage;
      this.selectLanguagePopup = false;
      if (this.treeContentType == "Digital_Image") {
        this.contentUploadPopup = true;
      } else {
        this.createContentPopup = true;
      }
    },
    transformDataToTree(data) {
      const tree = [];
      const map = {};
      data.forEach((item) => {
        const type = item.type;
        if (!map[type]) {
          map[type] = {
            id: type,
            type: item.type,
            children: [],
          };
          tree.push(map[type]);
        }
        if (!map[type][item.codeValue]) {
          const details = {
            text: item.text,
            planId: item.planId,
            type: item.type,
            storageTypeEnum: item.storageTypeEnum,
            language: item.language,
            codeValue: item.codeValue,
            documentId: item.documentId,
            children: [],
          };
          let codeValueChild = map[type].children.find(
            (child) => child.codeValue === item.codeValue
          );
          if (!codeValueChild) {
            codeValueChild = {
              codeValue: item.codeValue,
              children: [],
            };
            map[type].children.push(codeValueChild);
          }
          let languageChild = codeValueChild.children.find(
            (child) => child.language === item.language
          );

          if (!languageChild) {
            languageChild = {
              language: item.language,
              children: [details],
            };
            codeValueChild.children.push(languageChild);
          } else {
            languageChild.children.push(details);
          }
        } else {
          map[type].children
            .find((child) => child.language === item.language)
            .children.push({ text: item.text });
        }
      });
      return tree;
    },
    async createPlanContentMethod() {
      try {
        // this.loading = true;
        let payload = {
          screen: "",
          data:{
            planId: "",
              type: "",
              text: this.content,
              locale: "",
              tagId: "",
            }
        };
        if (this.planId) {
          payload.data.planId = this.planId;
          payload.screen = "plan";
        }
        if (this.discId) {
          payload.data.planId = this.discId;
          payload.screen = "discount";
        }
        if (this.promoId) {
          payload.data.planId = this.promoId;
          payload.screen = "promotion";
        }
        if (this.treeSelectedLanguage && this.treeContentType) {
          payload.data.type = this.treeContentType;
          payload.data.locale = this.treeSelectedLanguage;
          payload.data.tagId = this.selectedContentTagValue;
        } else {
          payload.data.type = this.selectedType.mCodeValue;
          payload.data.locale = this.selectedLanguage;
          payload.data.tagId = this.selectedContentTagValue;
        }
        this.createContentPopup = false;
        this.contentUploadPopup = false;
        await this.$store.dispatch("planPrice/createPlanContentAction", {
          ...payload,
          headers: {
            "Content-Type": "application/json",
          },
        });
        await this.fetchTermsConditions();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Digital Content Created Successfully!",
          type: "success",
        });
        this.selectedType = null;
        this.content = "";
        this.treeSelectedLanguage = null;
        this.treeContentType = null;
        this.selectedNewLanguage = null;
        this.selectedNewType = null;
        this.selectedContentTag = null;
        this.selectedContentTagValue = null;
      } catch (e) {
        await this.fetchTermsConditions();
        this.selectedType = null;
        this.content = "";
        this.treeSelectedLanguage = null;
        this.treeContentType = null;
        this.$swal({
          title: "Error",
          icon: "error",
          text: e.message.errors[0].defaultUserMessage,
          type: "error",
        });
      }
    },
    uploadOnChange(file) {
      this.file = file ? file : null;
    },
    async updatePlanContentMethod() {
      try {
        let payload = {
          screen: "",
          data:{
            planId: this.editData.planId,
            type: this.editData.type,
            text: this.editData.text,
            locale: this.editData.locale,
            tagId: this.editData.contentTagId,
            // docId: this.editData.docId,
          }
        };
        if (this.planId) {
          payload.screen = "plan";
        }
        if (this.discId) {
          payload.screen = "discount";
        }
        if (this.promoId) {
          payload.screen = "promotion";
        }
        this.editContentPopup = false;
        await this.$store.dispatch("planPrice/editPlanContentAction", payload);
        await this.fetchTermsConditions();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Digital Content Updated Successfully!",
          type: "success",
        });
        this.selectedType = null;
        this.content = "";
      } catch (e) {
        this.selectedType = null;
        this.content = "";
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something Went Wrong!",
          type: "error",
        });
      }
    },
    async makerCheckerApproval() {
      try {
        this.$swal({
          title: "Do you want to send approval request?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.sendApproval();
              this.$router.push(`/setup/plan-pricing`);
            } catch (error) {
              this.$toasted.error("something went wrong!!");
            }
          }
        });
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async sendApproval() {
      try {
        await this.$store.dispatch("planPrice/sendApprovalAction", this.planId);
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Approval request sent!",
          type: "success",
        });
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    editContentData(data) {
      this.editContentPopup = true;
      this.editData.planId = data.planId;
      this.editData.text = data.text;
      this.editData.type = data.type;
      this.editData.locale = data.storageTypeEnum;
      this.editData.docId = data.documentId;

      const matchedItem = this.contentTagValueList.find(
        (item) => item.mCodeValue === data.codeValue
      );
      this.editData.contentTagId = matchedItem ? matchedItem.id : null;
    },
    viewContentData(data) {
      this.viewContentPopup = true;
      this.editData.text = data.text;
    },
    async deleteContentData(data) {
      const payload = {
        id: data.planId,
        docId: data.documentId,
      };
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Digital Content Deleted Successfully!",
        type: "success",
      });
      this.deleteContentPopup = false;
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Digital Content Deleted Successfully!",
        type: "success",
      });
      try {
        await this.$store.dispatch("planPrice/deleteContentAction", payload);
        await this.fetchTermsConditions();
      } catch (error) {
        this.$toasted.error("Something Went Wrong", {
          duration: 2000,
        });
      }
    },

    async fetchTermsConditions() {
      const SelectedLanguage = this.LanguageList.find(
        (lang) => lang.id === this.selectedLanguage
      );
      const data = {
        id: "",
        lang: "",
        type: "",
        screen: "",
      };
      if (this.planId) {
        data.id = this.planId;
        data.screen = "plan";
      }
      if (this.discId) {
        data.id = this.discId;
        data.screen = "discount";
      }
      if (this.promoId) {
        data.id = this.promoId;
        data.screen = "promotion";
      }
      if (SelectedLanguage) {
        data.lang = SelectedLanguage.value;
      } else {
        data.lang = "en";
      }
      if (this.selectedType && this.selectedType.value) {
        data.type = this.selectedType.value;
      }
      try {
        await this.$store.dispatch("planPrice/setTermsConditions", data);
        this.treeData = this.transformDataToTree(this.termsAndConditions);
      } catch (e) {
        //
      }
    },
    async getLocaleLanguageMethod() {
      try {
        await this.$store.dispatch("planPrice/getLocaleLanguageAction");
      } catch (e) {
        //
      }
    },
    async getContentTagMethod() {
      try {
        await this.$store.dispatch("planPrice/getContentTagAction");
      } catch (e) {
        //
      }
    },
    async getContentTagValueMethod() {
      try {
        await this.$store.dispatch("planPrice/getContentTagValueAction");
      } catch (e) {
        //
      }
    },
    async getContentTypeMethod() {
      try {
        await this.$store.dispatch("planPrice/getContentTypeAction");
      } catch (e) {
        //
      }
    },
    async getDiscountContentTypeMethod() {
      try {
        await this.$store.dispatch("planPrice/getDiscountContentTypeAction");
      } catch (e) {
        //
      }
    },
    async getPromoContentTypeMethod() {
      try {
        await this.$store.dispatch("planPrice/getPromoContentTypeAction");
      } catch (e) {
        //
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getLocaleLanguageMethod();
    await this.getContentTagMethod();
    await this.getContentTagValueMethod();
    if (this.planId) {
      await this.getContentTypeMethod();
    }
    if (this.discId) {
      await this.getDiscountContentTypeMethod();
    }
    if (this.promoId) {
      await this.getPromoContentTypeMethod();
    }
    await this.getContentTypeMethod();
    await this.fetchTermsConditions();
    this.loading = false;
  },
};
</script>
<style lang="scss">
.swal2-popup {
  text-align: center;
}
.popup-width .vs-popup {
  width: 900px !important;
}
.popup-width .ql-snow .ql-tooltip {
  left: 10px !important;
}
.min-w-14vw {
  min-width: 14vw;
}
.digital-card {
  min-height: 50vh;
}
.tag-approval {
  border: 2px solid rgb(14, 140, 224);
  color: rgb(23, 180, 228);
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
</style>
